import couponService from '@/modules/coupon-service';

const state = {
	status: {},
	couponCode: '',
	selectedSubscription: null,
};

const getters = {
	couponStatus: state => state.status,
	couponCode: state => state.couponCode
};

function selectPerpetualSub(subs, tierName) {
	return subs.find(sub => sub.plan.tierName === tierName);
}

const actions = {
	'GET_COUPON_DETAILS':({ commit, dispatch, rootGetters }, couponCode) => {
		return couponService.getCouponDetails(couponCode)
			.then(coupon => {
				if (coupon.isMaintenance) {
					// get selected subscription
					const perpetualSubs = rootGetters['scope/perpetualScopeSubs'];

					if (perpetualSubs.length) {
						const selectedSub = selectPerpetualSub(perpetualSubs, coupon.tierName);
						if (selectedSub) {
							coupon.calculateMaintenanceExpiry(coupon.durationInMonths, selectedSub.maintenanceEnds);
							dispatch('SELECT_SUBSCRIPTION', selectedSub);
						}
					}
				}
				return coupon;
			});
	},
	'GET_MAINTENANCE_COUPON_DETAILS':({ commit, dispatch, rootGetters }, {couponCode, currentSub}) => {
		return couponService.getMaintenanceCouponDetails(couponCode, currentSub)
			.then(coupon => {
				coupon.calculateMaintenanceExpiry(coupon.durationInMonths, currentSub.maintenanceEnds);
				return coupon;
			});
	},
	//quick and dirty way to update maintenance expiry when switching subs. this could all be moved to state and use a getter
	'UPDATE_MAINTENANCE_EXPIRY':({ commit, dispatch, rootGetters }, {coupon, currentSub}) => {
		coupon.calculateMaintenanceExpiry(coupon.durationInMonths, currentSub.maintenanceEnds);
		return Promise.resolve(coupon);
	},
	'SELECT_SUBSCRIPTION': ({ commit }, selectedSub) => {
		commit('SELECT_SUBSCRIPTION', selectedSub);
	}
};

const mutations = {
	'SELECT_SUBSCRIPTION': (state , selectedSub) => {
		state.selectedSubscription = selectedSub;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/coupon.js